"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
var sortObjectKeysAlphabetically = exports.sortObjectKeysAlphabetically = function sortObjectKeysAlphabetically(obj) {
  var sorted = {};
  Object.keys(obj).sort().forEach(function (key) {
    sorted[key] = obj[key];
  });
  return sorted;
};

exports.default = sortObjectKeysAlphabetically;